import { Affiliate } from '../../models/affiliate';

// Marketing site base. Co-branded landing pages now live on the marketing site
// (not in web-app), so the login header's nav points there.
const MARKETING_BASE_URL = 'https://www.ayblehealth.com';

// "How it works" is a real marketing page (/how-it-works). The marketing site has
// no FAQ page, so "FAQs" is only surfaced when an affiliate provides its own faq_link.
export const DEFAULT_HOW_IT_WORKS_URL = `${MARKETING_BASE_URL}/how-it-works`;

export type LoginNavLinks = {
  howItWorksUrl: string;
  faqUrl?: string;
};

export const getLoginNavLinks = (
  affiliate?: Affiliate | null
): LoginNavLinks => ({
  howItWorksUrl: DEFAULT_HOW_IT_WORKS_URL,
  faqUrl: affiliate?.faq_link || undefined,
});
